/**
 * API Configuration
 *
 * Provides API base URLs from Vite environment variables.
 * Uses import.meta.env which Vite replaces at build time.
 *
 * In tests, mock this module:
 *   jest.mock('../config/api.config', () => ({ USER_API_URL: 'https://test-api/user' }));
 */

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const env: Record<string, string | undefined> = (typeof import.meta !== 'undefined' && import.meta.env) || {};

export const USER_API_URL: string = (env.VITE_USER_API_URL as string) || 'https://dev-api.nodegeeks.org/user';
export const WEBHOOKS_API_URL: string = (env.VITE_WEBHOOKS_API_URL as string) || 'https://dev-api.nodegeeks.org/webhooks';
// Tenant management + tenant selection endpoints are owned by the dedicated tenant-api
// (base path `/tenant`), not the user-api.
export const TENANT_API_URL: string = (env.VITE_TENANT_API_URL as string) || 'https://dev-api.nodegeeks.org/tenant';
// Onboarding API — tenant registration & availability check for authenticated users
export const ONBOARDING_API_URL: string = (env.VITE_ONBOARDING_API_URL as string) || 'https://dev-api.nodegeeks.org/onboarding';
